<template>
  <div id="app">
    <!-- <Header /> -->
    <transition name="pageTransition">
      <Construction />
    </transition>
  </div>
</template>

<script>
import Header from "./components/Header"
import Construction from "./views/Construction"

export default {
  name: 'App',
  components: {
    Header,
    Construction
  }
}
</script>

<style lang="scss">
@import "./stylesheets/bootstrap/bootstrap-reboot";
@import "./stylesheets/bootstrap/bootstrap-grid";
@import "./stylesheets/bootstrap/_buttons";
@import "./stylesheets/bootstrap/_utilities";
@import "./stylesheets/bootstrap/_forms";

@import "./stylesheets/variables";

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Helvetica Neue', sans-serif;
  background: #fffcfc;
}

// page transition
.pageTransition-enter-active, .pageTransition-leave-active {
  transition: transform 750ms, opacity 500ms;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.pageTransition-enter-active {
  z-index: 2;
  opacity: 1;
}
.pageTransition-leave-active {
  z-index: 1;
}
.pageTransition-enter {
  transform: translateX(100%);
  opacity: 0;
}

// global styles
.btn {
  &.btn-primary {
    // background-image: linear-gradient(221deg, #FF0000 0%, #8A0000 100%);
    background-color: $red;
    border-radius: 0;
    color: white;
    border: 1px solid transparent;
    font-size: 16px;
    font-weight: 500;

    &:hover {
      border-width: 1px;
      border-color: $red;
      background-color: white;
      background-image: none;
      color: $red;
    }
  }

  &.btn-black {
    background-color: black;
    color: white;
    border-radius: 0;
    border: 1px solid black;
    font-size: 16px;
    font-weight: 500;

    &:hover {
      border-width: 1px;
      border-color: lighten(black, 10%);
      background-color: lighten(black, 10%);
      color: white;
    }
  }
}

a {
  transition: color 250ms;
}

form.form.email {
  div.form-group {
    text-align: center;
    position: relative;

    label {
      opacity: 0;
      transition: opacity 250ms;
      font-size: 14px;
      color: #4a4a4a;
      font-weight: 700;
      position: absolute;
      top: -20px;
      left: 0;

      &.visible {
        opacity: 1;
      }
    }

    input[type="email"] {
      border-width: 0 0 1px 0;
      border-radius: 0;
      border-color: black;
      font-size: 18px;
      font-weight: 500;
      color: #4a4a4a;
      padding: 25px 10px;

      &::placeholder {
        color: black;
      }

      &:active,
      &:focus {
        outline: none;
        box-shadow: none;
        border-bottom-color: $red;
      }
    }

    button.btn.btn-primary {
      margin-top: 20px;
      padding: 10px 70px;
    }
  }
}
</style>
